import { useEffect, useRef, useState } from 'react';
import { sqAxiosStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import clsx from 'clsx';

interface LoadingSpinnerProps {
  noToolName?: boolean;
}

/**
 * This component encapsulates the "loading indicator" spinner
 */
export const LoadingSpinner: React.FunctionComponent<LoadingSpinnerProps> = ({ noToolName }) => {
  const SPINNER_HIDE_DELAY = 1000;

  const { pendingRequests } = useFlux(sqAxiosStore);
  const previousRequests = useRef(0);
  const spinnerTimeout = useRef<number>(0);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    const hasActiveRequests = pendingRequests > 0;

    clearTimeout(spinnerTimeout.current);

    if (hasActiveRequests) {
      setShowSpinner(true);
    } else if (previousRequests.current > 0) {
      spinnerTimeout.current = window.setTimeout(() => {
        setShowSpinner(false);
      }, SPINNER_HIDE_DELAY);
    }

    previousRequests.current = pendingRequests;
  }, [pendingRequests]);

  useEffect(() => {
    return () => clearTimeout(spinnerTimeout.current);
  }, []);

  const marginTop = noToolName ? 'mt4' : 'mt10';

  return (
    <div className={clsx(`pl10 width-30`, marginTop, showSpinner ? 'visible' : 'hidden')}>
      <div className="ml20 mt4" data-title="dot-pulse">
        <div className="stage">
          <div className="dot-pulse"></div>
        </div>
      </div>
    </div>
  );
};
